<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <WizardHeader :title="$t('account_settings_legal.investment_objectives')" :icon="UsersIcon"></WizardHeader>
            <div class="px-4 py-3 sm:px-6">
                <LegalInvestmentObjectivesForm v-model="formValues"></LegalInvestmentObjectivesForm>
            </div>
        </template>
        <template #nextButton>
            <BaseButtonPrimary
                :loading="usePersonalAccountDataState().saving"
                :disabled="usePersonalAccountDataState().saving || formState.hasValidationErrors"
                size="lg"
                @click="submit()"
                >{{ $t('widget.save') }}
            </BaseButtonPrimary>
        </template>
        <template #previousButton>
            <BaseButtonMuted size="lg" @click="navigateToPreviousTab()">{{ $t('widget.back') }}</BaseButtonMuted>
        </template>

        <template #sidebar>
            <p class="pb-2 pb-2 text-base text-gray-800">
                {{ $t('esac_widget_sidebar.legal_entity_investment_profile') }}
            </p>
        </template>
    </WizardTabWithSidebar>
</template>

<script setup lang="ts">
import WizardTabWithSidebar from '../../WizardTabWithSidebar.vue'
import WizardHeader from '../../WizardHeader.vue'
import BaseButtonPrimary from '../../../base/BaseButtonPrimary.vue'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { InvestmentTargets, usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { useLegalAccountFormState } from '../../../../utilities/account/useAccountFormLegal'
import { inject, onMounted, reactive, ref } from 'vue'
import { UsersIcon } from '@heroicons/vue/outline'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import LegalInvestmentObjectivesForm from './form/LegalInvestmentObjectivesForm.vue'
import { LegalEsacComplianceProfile } from './form/forms'

const formState = useLegalAccountFormState()
const { navigateToNextTab, navigateToPreviousTab, navigateToTab } = inject('navigation')

const formValues = ref(new InvestmentTargets())

onMounted(() => {
    if (useLegalAccountDataState().legalProfile.compliance_profiles.esac) {
        formValues.value = useLegalAccountDataState().legalProfile.compliance_profiles.esac.investment_targets
    }
})

async function submit() {
    const { valid } = await formState.currentForm.validate()
    if (valid) {
        if (!useLegalAccountDataState().legalProfile.compliance_profiles.esac) {
            useLegalAccountDataState().legalProfile.compliance_profiles = { esac: new LegalEsacComplianceProfile() }
        }
        useLegalAccountDataState().legalProfile.compliance_profiles.esac.investment_targets = formValues.value
        await formState.submit()
        navigateToNextTab()
    }
}
</script>

<style scoped></style>
